<template>
  <b-col cols="12">
    <b-card no-body>
      <b-card-header>
        <h3>Fahrerhistorie</h3>
      </b-card-header>
      <b-card-body>
        <b-table bordered
                 fixed
                 :items="list"
                 :fields="fields"
        >
          <template v-slot:cell(driver.dayofbirth)="data">
            {{ data.item.driver.dayofbirth | formatDate }}
          </template>
          <template v-slot:cell(actions)="data">
            <div class="text-center">
              <b-button-group size="sm">
                <b-button variant="info" v-on:click="showEditForm(data.item)">
                  <i class="fas fa-pencil-alt"></i>
                </b-button>
                <b-button v-if="data.item.to_date.startsWith('9999')" variant="warning"
                          v-on:click="closeEntry(data.item)">
                  <i class="fas fa-ban"></i>
                </b-button>
                <!--<b-button variant="danger" v-on:click="deleteEntry(data.item.id)">
                  <i class="fas fa-trash"></i>
                </b-button>-->
              </b-button-group>
            </div>
          </template>
        </b-table>
      </b-card-body>
    </b-card>
    <driverhistory-entry-change-form
      :show.sync="showModal"
      :item.sync="activeItem"
      v-on:update:show="showModal = $event"
      @updateEntry="updateEntry"
    ></driverhistory-entry-change-form>
  </b-col>
</template>

<script>
    import { fetchVehicleHistory, deleteVehicleHistoryEntry, updateVehicleHistoryEntry } from '@/api/vehicle'
    import driverhistoryEntryChangeForm from '@/views/vehicleManagement/vehicle/components/driverhistoryEntryChangeForm'
    import moment from 'moment'

    export default {
        name: "driverHistorieList",
        data() {
            return {
                fields: [
                    {
                        key: 'from_date',
                        label: 'Von',
                        sortable: true,
                        thStyle: {
                            align: "center",
                            width: '120px'
                        },
                    },
                    {
                        key: 'to_date',
                        label: 'Bis',
                        sortable: true,
                        thStyle: {
                            align: "center",
                            width: '120px'
                        },
                    },
                    {
                        key: 'driver.lastname',
                        label: 'Nachname',
                        sortable: true,
                        thStyle: {
                            align: "center",
                            width: '120px'
                        },
                    },
                    {
                        key: 'driver.firstname',
                        label: 'Vorname',
                        sortable: true,
                        thStyle: {
                            align: "center",
                            width: '120px'
                        },
                    },
                    {
                        key: 'driver.dayofbirth',
                        label: 'Geburtsdatum',
                        sortable: true,
                        thStyle: {
                            align: "center",
                            width: '120px'
                        },
                    },
                    {
                        key: 'driver.address.address_line_2',
                        label: 'Str. + HNr.',
                        sortable: true,
                        thStyle: {
                            align: "center",
                            width: '120px'
                        },
                    },
                    {
                        key: 'driver.address.postcode',
                        label: 'PLZ',
                        sortable: true,
                        thStyle: {
                            align: "center",
                            width: '120px'
                        },
                    },
                    {
                        key: 'driver.address.city',
                        label: 'Ort',
                        sortable: true,
                        thStyle: {
                            align: "center",
                            width: '120px'
                        },
                    },
                    {
                        key: 'actions',
                        label: 'Aktionen',
                        sortable: true,
                        thStyle: {
                            align: "center",
                            width: '120px'
                        },
                    },
                ],
                list: [],
                loading: false,
                showModal: false,
                activeItem: {driver: {}},
            }
        },
        components: {
            driverhistoryEntryChangeForm
        },
        created() {
            this.getList();
        },
        props: {
            vehicle_id: String,
        },
        methods: {
            async getList() {
                this.loading = true;
                const {data} = await fetchVehicleHistory(this.vehicle_id);
                this.list = data;
                //Sort DATA by from_date
                data.sort(function(a, b) {
                    a = new Date(a.from_date);
                    b = new Date(b.from_date);
                    return a > b ? -1 : a < b ? 1 : 0;
                });
                this.total = data.length;
                this.loading = false;
            },
            async deleteEntry(id) {
                this.loading = true;
                await deleteVehicleHistoryEntry(this.vehicle_id, id);
                this.loading = false;
            },
            showEditForm(item) {
                this.activeItem = Object.assign({}, item);
                this.showModal = true;
            },
            async updateEntry(item) {
                this.loading = true;
                try {
                    await updateVehicleHistoryEntry(this.vehicle_id, item.id, item);
                } catch (e) {
                    this.loading = false;
                    await this.getList();
                    return;
                }
                this.loading = false;
                await this.getList();
            },
            async closeEntry(item) {
                this.loading = true;
                item.to_date = moment(new Date().getTime()).format("YYYY-MM-DD HH:mm:ss");
                try {
                    await updateVehicleHistoryEntry(this.vehicle_id, item.id, item);
                } catch (e) {
                    this.loading = false;
                    await this.getList();
                    return;
                }
                this.loading = false;
                await this.getList();
            }
        }
    }
</script>

<style scoped>
  /deep/ .table > tbody > tr > td {
    vertical-align: middle !important;
  }
</style>
